import './style.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as reportActions from '../../redux/actions/report.action'
import NumberFormat from 'react-number-format'
import { RootReducers } from '../../redux/reducers'
import { HeaderBar } from '../../component/HeaderBar'
import { ChangeEvent, useEffect, useState } from 'react'
import { CSVLink, CSVDownload } from 'react-csv'
import errorAlert from '../../assets/images/error-alert.svg'
import {
  DisplayDateReportFormatNoTime,
  DisplayToThaiDateFormat,
  ReportDateFormat
} from '../../helpers/texthelper'
import { WatDatePicker } from '../../component/datePicker'

export const StaffReport = () => {
  const rightNow = new Date()
  const dispatch = useDispatch()

  const [formErrors, setFormErrors] = useState<any>({})
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const reportData = useSelector((state: RootReducers) => state.reportReducer)
  const [startDate, setstartDate] = useState(new Date())
  const [endDate, setendDate] = useState(new Date())
  const [csvResult, setCsvResult] = useState<any>()
  const [isShowDownload, setIsShowDownload] = useState(false)
  const [reportName, setreportName] = useState(
    `report_etr_${loginState.account?.agentInfo.agentId}_${rightNow
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, '')}.csv`
  )

  useEffect(() => {
    console.log('New value')
    //console.log(reportData.data)
    createCSVData()
    return () => {
      console.log('Prev value')
    }
  }, [reportData])

  const csvData: any[] = []
  const rowHearder: any[] = []
  rowHearder.push('Agent Code')
  rowHearder.push('Agent Name')
  rowHearder.push('Branch Name')
  rowHearder.push('Receipt No.')
  rowHearder.push('Receipt Date')
  rowHearder.push('Policy No.')
  rowHearder.push('Insured Name')
  rowHearder.push('Payment Amount')
  rowHearder.push('Payment Method')
  rowHearder.push('hasChangeEmailOrMobile')
  rowHearder.push('NewCustomerMail')
  rowHearder.push('CustomerMailCore')
  rowHearder.push('NewCustomerPhone')
  rowHearder.push('CustomerPhoneCore')
  rowHearder.push('Status')
  rowHearder.push('ETR Status Date')
  rowHearder.push('DCR Status Date')
  rowHearder.push('User Name')
  rowHearder.push('Remark')
  csvData.push(rowHearder)
  const createCSVData = () => {
    reportData.data &&
      reportData.data.forEach((item: any) => {
        item.documentDetails.forEach((docDetail: any) => {
          const rowData: any[] = []
          rowData.push(item.agent.agentId)
          rowData.push(item.agent.name)
          rowData.push(item.branchName || item.agent.branchName)
          rowData.push(item.receiptNo)
          rowData.push(DisplayDateReportFormatNoTime(item.receiptdate))
          rowData.push(item.policyNo)
          rowData.push(item.insuredName)
          rowData.push(docDetail.paymentAmount)
          rowData.push(docDetail.paymentMethod?.name)
          rowData.push(item.hasChangeEmailOrMobile)
          rowData.push(item.customerMail)
          rowData.push(item.customerMailCore)
          rowData.push(item.customerPhone)
          rowData.push(item.customerPhoneCore)
          rowData.push(item.status)
          rowData.push(DisplayDateReportFormatNoTime(item.etrStatusDate))
          rowData.push(DisplayDateReportFormatNoTime(item.dcrStatusDate))
          rowData.push(item.updateBy)
          rowData.push(item.remark || item.statusReason)
          csvData.push(rowData)
        })
      })
    setCsvResult(csvData)
  }

  const handleExportClick = () => {
    const reportParam = {
      email: loginState.account?.agentInfo.email,
      staff: loginState.account?.agentInfo.userName,
      startdate: ReportDateFormat(startDate),
      enddate: ReportDateFormat(endDate)
    }
    console.log(reportParam)
    dispatch(reportActions.getReport(reportParam))
    setIsShowDownload(true)
  }

  const handleWatDatePickerStartDate = (christDate: any, buddhistDate: any) => {
    setstartDate(christDate)
  }
  const handleWatDatePickerEndDate = (christDate: any, buddhistDate: any) => {
    setendDate(christDate)
  }

  return (
    <div>
      <HeaderBar>
        <div className="header-bar-text">e-TR Report</div>
      </HeaderBar>
      <div className="container">
        <div className="form-content">
          <form>
            <label className="report-label-input">
              <span>รายงาน</span>
              <select name="report" id="report" className={`field-input`}>
                <option value="report1">รายงาน e-TR สำหรับพนักงานสาขา</option>
              </select>
            </label>
            <div className="report-label-input">
              <span>วันที่เริ่มต้น วัน/เดือน/ปี (พ.ศ.)</span>
              <WatDatePicker
                className={`amount-input ${formErrors.cheque_Date && 'error-border-validate'}`}
                name="startDate"
                onChange={handleWatDatePickerStartDate}
                dateFormat={'yyyy-MM-dd'}
                displayFormat={'DD/MM/YYYY'}
                clearable={false}
                // minDate={dayjs().add(-2, 'year')}
                // maxDate={dayjs().add(5, 'year')}
                disabled={false}
                readOnly={false}
                value={startDate}
                yearBoundary={99}
                inputStyle={formErrors.cheque_Date ? { borderColor: '#b30909' } : null}
              />
              {formErrors.startDate && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูลให้ถูกต้อง {DisplayToThaiDateFormat(new Date())}
                </div>
              )}
            </div>
            <div className="report-label-input">
              <span>วันที่สิ้นสุด วัน/เดือน/ปี (พ.ศ.)</span>
              <WatDatePicker
                className={`amount-input ${formErrors.cheque_Date && 'error-border-validate'}`}
                name="endDate"
                onChange={handleWatDatePickerEndDate}
                dateFormat={'yyyy-MM-dd'}
                displayFormat={'DD/MM/YYYY'}
                clearable={false}
                // minDate={dayjs().add(-2, 'year')}
                // maxDate={dayjs().add(5, 'year')}
                disabled={false}
                readOnly={false}
                value={endDate}
                yearBoundary={99}
                inputStyle={formErrors.cheque_Date ? { borderColor: '#b30909' } : null}
              />

              {formErrors.endDate && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  กรุณากรอกข้อมูลให้ถูกต้อง {DisplayToThaiDateFormat(new Date())}
                </div>
              )}
            </div>
            <div className="search-staff-button-content">
              <button type="button" className="search-staff-button" onClick={handleExportClick}>
                ค้นหา
              </button>
            </div>
          </form>
          <div className="download-content">
            {reportData.isFetching && <div className="loader"></div>}
            {isShowDownload && csvResult && `ข้อมูลจำนวน ${reportData.data?.length} รายการ`}

            {isShowDownload && csvResult && (
              <CSVLink className="download-link" data={csvResult} filename={reportName}>
                Download
              </CSVLink>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
